/**
 * Regex pattern to match plain currency symbols.
 *
 * \p{Sc} - Matches any Unicode currency symbol character
 *   This includes: $, €, £, ¥, ₹, ₽, ₩, ₴, ₫, ₿, etc.
 *
 * Pattern flags:
 * g - Global flag, finds all matches in the string
 * u - Unicode flag, enables correct handling of Unicode properties like \p{Sc}
 *     Without this flag, Unicode property escapes won't work correctly
 */
export const REGEX_CURRENCY_SYMBOLS = /\p{Sc}/gu;

/**
 * Matches 2 or more consecutive whitespace characters
 * \s{2,} - Matches two or more whitespace characters in a row
 * g flag - Global match (find all matches rather than stopping after the first)
 */
export const REGEX_MULTIPLE_WHITESPACE = /\s{2,}/g;
